import { useCallback } from 'react';
import { JsonDataItem } from 'types';

type ExtraQuestion = {
  product_id: string;
  name: string;
  value: any;
};

export const useExtraQuestionsData = () => {
  const getExtraQuestionsData = useCallback((formData: JsonDataItem): ExtraQuestion[] => {
    const result: ExtraQuestion[] = [];

    for (const key in formData) {
      if (key.startsWith('extraQuestion')) {
        const nameParts = key.split('-');
        const productId = nameParts[2];
        const questionName = nameParts[4];
        result.push({
          product_id: productId,
          name: questionName,
          value: formData[key],
        });
      }
    }

    return result;
  }, []);

  return { getExtraQuestionsData };
};
